import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { SEOHead } from './components/SEOHead';
import { Toaster } from './components/ui/sonner';
import { Home } from './pages/Home';
import { ChiSiamo } from './pages/ChiSiamo';
import { Servizi } from './pages/Servizi';
import { Processo } from './pages/Processo';
import { Sostenibilita } from './pages/Sostenibilita';
import { Professionisti } from './pages/Professionisti';
import { Contatti } from './pages/Contatti';
import { Admin } from './pages/Admin';
import { Privacy } from './pages/Privacy';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SEOHead />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/processo" element={<Processo />} />
            <Route path="/sostenibilita" element={<Sostenibilita />} />
            <Route path="/professionisti" element={<Professionisti />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
